import ServicePageHero from "../components/ServicePageHero";
import { openConsultationMail } from "../config/contact";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiArrowUpRight, FiPlus, FiChevronDown, FiChevronUp, FiTarget, FiTrendingUp, FiBarChart2, FiSettings } from "react-icons/fi";
import { Helmet } from "react-helmet-async";
import ServiceDetailSection from "../components/ServiceDetailSection";
import ServiceIntroSection from "../components/ServiceIntroSection";
import img_charts_amico from "../assets/Charts-amico.png";
import img_conversion_rate_optimization_amico_1 from "../assets/Conversion rate optimization-amico (1).png";
import img_conversion_rate_optimization_pana_1 from "../assets/Conversion rate optimization-pana (1).png";
import img_generating_new_leads_amico from "../assets/Generating new leads-amico.png";
import img_multi_device_targeting_amico from "../assets/Multi-device targeting-amico.png";
import img_projections_cuate_1 from "../assets/Projections-cuate (1).png";
import img_about_img1 from "../assets/Choose-bro.png";
import img_about_img2 from "../assets/Starting a business project-amico.png";

// Using specific assets for PPC 

const FAQ_DATA = [
  {
    question: "1. What is PPC advertising?",
    answer: "PPC (Pay-Per-Click) advertising is a digital marketing method where you pay for each click on your ad. It helps drive instant traffic to your website through platforms like Google Ads."
  },
  {
    question: "2. How quickly can I see results from PPC?",
    answer: "PPC campaigns can start generating traffic and leads almost immediately after launch. However, performance improves over time with continuous optimization."
  },
  {
    question: "3. Is PPC suitable for small businesses?",
    answer: "Yes, PPC is highly effective for small businesses as it allows you to target specific audiences and control your budget while generating quick results."
  },
  {
    question: "4. How do you measure PPC performance?",
    answer: "We track key metrics such as clicks, conversions, and return on investment (ROI) to evaluate and improve campaign performance."
  }
];

const scrollReveal = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.6, ease: "easeOut" },
};

const staggerContainer = {
  initial: {},
  whileInView: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemFade = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.5, ease: "easeOut" },
};


const WHY_ICONS = [
  <FiTarget />,
  <FiTrendingUp />,
  <FiBarChart2 />,
  <FiSettings />,
];
const PpcServicesPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [activeWhy, setActiveWhy] = useState(0);
  const toggleFaq = (i) => setOpenFaq(openFaq === i ? null : i);

  const scrollToContact = openConsultationMail; // replaced

  return (
    <>
      <Helmet>
        <title>PPC Services Company | Google Ads Experts in India</title>
        <meta name="description" content="Get more leads with expert PPC services. Hire a Google Ads company in India for high-converting ad campaigns and better ROI." />
      </Helmet>
      <main className="ppc-services-page">
      <ServicePageHero
        badge="Our Services"
        title="Best PPC Services"
        subtitle="Drive instant traffic, generate quality leads, and maximize ROI with targeted ad campaigns."
        breadcrumb="Home > Services > PPC Advertising"
        image={img_conversion_rate_optimization_amico_1}
      />


      {/* INTRO SECTION */}
      <ServiceIntroSection
        heading="How PPC Advertising Grows Your Business"
        imageLeft={img_generating_new_leads_amico}
        imageRight={img_conversion_rate_optimization_pana_1}
        paragraph1="Pay-Per-Click advertising helps your business reach potential customers instantly through platforms like Google Ads. It is one of the fastest ways to generate traffic and leads."
        paragraph2="As a performance-driven PPC agency, we create targeted ad campaigns that bring the right audience to your website while ensuring maximum return on investment."
      />

      <ServiceDetailSection
        isReversed={false}
        label="Our PPC Strategy"
        title="Keyword Research & Campaign Strategy"
        description="We identify high-intent keywords and create a campaign strategy aligned with your business goals. This helps in targeting users who are actively searching for your services."
        longDescription="With the right planning, we ensure your ads reach the right audience at the right time."
        image={img_charts_amico}
      />

      <ServiceDetailSection
        isReversed={true} bgLight
        title="Ad Creation & Optimization"
        description="We create compelling ad copies and creatives designed to attract attention and improve click-through rates. Our focus is on making your ads relevant and effective."
        longDescription="Continuous optimization ensures better performance and improved results over time."
        image={img_multi_device_targeting_amico}
      />

      <ServiceDetailSection
        isReversed={false}
        title="Audience Targeting & Budget Management"
        description="We carefully target your audience based on location, interests, and search behavior. This helps in reaching potential customers who are more likely to convert."
        longDescription="We also manage your budget efficiently to maximize results without unnecessary spending."
        image={img_projections_cuate_1}
      />

      <ServiceDetailSection
        isReversed={true} bgLight
        title="Performance Tracking & Improvement"
        description="We monitor key metrics like clicks, conversions, and ROI to understand campaign performance. Based on insights, we continuously improve the strategy."
        longDescription="This ensures your PPC campaigns deliver consistent and measurable results."
        image={img_multi_device_targeting_amico}
      />

      {/* WHY CHOOSE US - REDESIGNED DARK VERSION */}
      <section className="dark-why-section">
        <div className="container-custom">
          <motion.div className="dark-why-header" {...scrollReveal}>
            <span className="dark-why-badge">Why Choose Us</span>
            <h2>Why Businesses Trust Our PPC Expertise</h2>
          </motion.div>

          <motion.div 
            className="dark-why-grid"
            variants={staggerContainer}
            initial="initial"
            whileInView="whileInView"
            viewport={{ once: true, amount: 0.1 }}
          >
            {/* Left: Accordion List */}
            <motion.div className="dark-why-list" variants={itemFade}>
              {[
                { 
                  title: "1. Targeted Campaigns", 
                  desc: "We focus on reaching the right audience with well-planned ad campaigns. This improves lead quality and increases conversion chances. Our strategies are designed to deliver better results with optimized targeting." 
                },
                { 
                  title: "2. Focus on ROI", 
                  desc: "We prioritize return on investment by optimizing campaigns for better performance. Our goal is to generate maximum value from your ad spend. This helps your business achieve better results without overspending." 
                },
                { 
                  title: "3. Transparent Reporting", 
                  desc: "We provide clear insights into campaign performance, including clicks, conversions, and results. This keeps you informed at every step. You always know how your campaigns are performing and what improvements are being made." 
                },
                { 
                  title: "4. Continuous Optimization", 
                  desc: "We regularly analyze and optimize campaigns to improve performance. This helps in maintaining consistent growth and better outcomes. With ongoing improvements, we ensure long-term success for your campaigns." 
                }
              ].map((item, idx) => (
                <div 
                  key={idx} 
                  className={`dark-why-item ${activeWhy === idx ? 'active' : ''}`}
                  onMouseEnter={() => setActiveWhy(idx)}
                >
                  <div className="dark-why-item-header">
                    <span className="dark-why-item-icon-left">{WHY_ICONS[idx]}</span>
                    <h4>{item.title}</h4>
                    <span className="dark-why-item-icon">
                      {activeWhy === idx ? <FiArrowUpRight /> : <FiPlus />}
                    </span>
                  </div>
                  <div className="dark-why-item-content">
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </motion.div>

            {/* Right: Visual Ovals */}
            <motion.div className="dark-why-visual" variants={itemFade}>
              <img src={img_about_img1} alt="Expertise 1" className="dark-oval-1" />
              <img src={img_about_img2} alt="Expertise 2" className="dark-oval-2" />
              <span className="dark-deco-plus"><FiPlus /></span>
              <span className="dark-deco-star">✷</span>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="faq-section py-20">
        <div className="container-custom max-w-4xl">
          <motion.h2 className="section-title text-center mb-16" {...scrollReveal}>Frequently Asked Questions</motion.h2>
          <div className="faq-list">
            {FAQ_DATA.map((faq, index) => (
              <motion.div 
                key={index} 
                className={`faq-item ${openFaq === index ? 'active' : ''}`}
                {...scrollReveal}
                transition={{ delay: index * 0.1 }}
              >
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  {openFaq === index ? <FiChevronUp /> : <FiChevronDown />}
                </button>
                <AnimatePresence>
                  {openFaq === index && (
                    <motion.div 
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <p>{faq.answer}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="service-page-cta service-page-cta--soft py-20">
        <div className="container-custom">
          <motion.div 
            className="service-page-cta-inner text-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2>Start Driving Results with Paid Advertising</h2>
            <p className="mb-8">Our PPC services in Delhi NCR are designed to bring instant traffic, generate quality leads, and maximize your advertising performance.</p>
            <button className="nav-btn mx-auto" onClick={scrollToContact} style={{ padding: '14px 32px', fontSize: '16px' }}>
              Get Free Consultation
              <span className="nav-btn-arrow" style={{ width: '28px', height: '28px' }}>
                <FiArrowUpRight />
              </span>
            </button>
          </motion.div>
        </div>
      </section>
      </main>
    </>
  );
};

export default PpcServicesPage;
